import React from 'react';
import { IconButton, Tooltip, Stack } from '@mui/material';
import { Visibility, OpenInNew, Edit } from '@mui/icons-material';
import { CellDefaultProps, ProposalTableActions } from '../../../types';

type Props<TableData> = CellDefaultProps<TableData> & ProposalTableActions<TableData>;

export const ActionCell = <TableData extends any>({
  proposal,
  onEditProposal,
  onGoToProposal,
  onGoToProposalDetail,
}: Props<TableData>) => (
  <Stack direction="row" justifyContent="center">
    {!!onEditProposal && (
      <Tooltip title="Edit proposal">
        <IconButton color="primary" size="small" onClick={() => onEditProposal(proposal)}>
          <Edit color="primary" />
        </IconButton>
      </Tooltip>
    )}

    <Tooltip title="Go to proposal details">
      <IconButton color="primary" size="small" onClick={() => onGoToProposal(proposal)}>
        <Visibility color="primary" />
      </IconButton>
    </Tooltip>

    <Tooltip title="Go to proposal">
      <IconButton color="primary" size="small" onClick={() => onGoToProposalDetail(proposal)}>
        <OpenInNew color="primary" />
      </IconButton>
    </Tooltip>
  </Stack>
);
